import LocationWorkerType from "@/models/LocationWorkers/LocationWorkerType";

export default (value: LocationWorkerType) => {
    switch (value) {
        case LocationWorkerType.Favourite:
            return "Favourite";
        case LocationWorkerType.Blocked:
            return "Blocked";
    }
} 